import {
  CandidateSearchProfile,
  CandidateSearchResult
} from 'modules/candidate-profile/types/CandidateSearchResult';
import { SourcingSearchResponse } from 'modules/candidate-profile/types/CandidateSearchFilter';

/** Only the envelope differs; the candidate records already match. */
export const mapSourcingSearchResponse = (
  response: SourcingSearchResponse
): CandidateSearchResult => ({
  id: response.id ?? undefined,
  candidateProfiles: (response.candidates ?? []) as CandidateSearchProfile[],
  totalCandidatesCount: response.totalCandidatesCount ?? 0,
  newUserMessage: response.newUserMessage ?? undefined
});
